import _ from 'lodash';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import navigateTo from '../../../mixins/buy-flow';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import { getProductPriceTitle, resolveProductImage, routeToProduct } from '@/helpers';
import { debounce } from 'lodash';

import IconClose from '@/components/icons/IconClose.vue';
import IconMinus from '@/components/icons/IconMinus.vue';
import IconPlus from '@/components/icons/IconPlus.vue';

export default {
  name: 'Basket',
  components: {
    IconPlus,
    IconMinus,
    IconClose,
    VueSlickCarousel
  },
  mixins: [navigateTo],
  data() {
    return {
      syncPriceProductId: null,
      carouselKey: 1,
      promoCarouselKey: 1,
      selectedProductPrice: {},
      productsKey: 1,
      productsSlider: {
        infinite: true,
        centerPadding: '0',
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        centerMode: true,
        responsive: [
          {
            breakpoint: 672,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    };
  },
  created() {
    document.getElementById('html').classList.add('hide');
    this.getBuyTogetherProducts();
    this.getPromoOffers();
    this.resetRemovedSamples();
    this.checkOrderCart();
  },
  watch: {
    basket: function () {
      this.getBuyTogetherProducts();
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      user: 'profile/user',
      buyTogetherProducts: 'basket/buyTogetherProducts',
      promoOffers: 'basket/promoOffers',
      basket: 'basket/basket',
      samples: 'samples/samples',
      isSamplesLoading: 'samples/isSamplesLoading',
      gifts: 'gifts/gifts',
      isGiftsLoading: 'gifts/isGiftsLoading',
      hasUnselectedGifts: 'gifts/hasUnselectedGifts',
      giftGroups: 'gifts/giftGroups',
      selectedGifts: 'gifts/selectedGifts'
    }),
    selectedGiftProducts() {
      const rows = [];
      (this.selectedGifts || []).forEach((sel) => {
        const group = this.giftGroups.find((g) => g.id === sel.giftGroupId);
        if (!group) return;
        const variant = group.products.find((v) => v.productPriceId === sel.productPriceId);
        if (!variant) return;
        const price = variant.product?.productPrices?.data?.find(
          (p) => p.id === variant.productPriceId
        );
        rows.push({
          key: `${sel.giftGroupId}-${sel.productPriceId}`,
          title: variant.product.title,
          image: price?.image || variant.productImage || variant.product.image,
          count: sel.count,
          giftGroupId: sel.giftGroupId,
          productPriceId: sel.productPriceId
        });
      });
      return rows;
    },
    sortedBuyProducts() {
      return this.buyTogetherProducts.map((product) => ({
        ...product,
        productPrices: {
          data: product.productPrices.data.sort((a, b) => (a.value > b.value ? -1 : 1))
        }
      }));
    },
    sortedPromoOffers() {
      return this.promoOffers.map((product) => ({
        ...product,
        productPrices: {
          data: product.productPrices.data.sort((a, b) => (a.value > b.value ? -1 : 1))
        }
      }));
    },
    hideSliderArrows() {
      return this.shouldShowArrows(this.buyTogetherProducts.length);
    },
    hidePromoArrows() {
      return this.shouldShowArrows(this.promoOffers.length);
    },
    isShowTotalOldSum() {
      return this.basket.some((product) => product.select_type.oldPrice);
    },
    totalOldSum() {
      return _.sumBy(this.basket, (product) => {
        let { select_type, select_count } = product;
        let price = select_type.oldPrice || select_type.price;
        return price * select_count;
      });
    },
    totalSum() {
      return _.sumBy(this.basket, (product) => product.select_type.price * product.select_count);
    }
  },
  methods: {
    routeToProduct,
    getProductPriceTitle,
    resolveProductImage,
    ...mapActions({
      getSyncBasket: 'basket/GET_SYNC_BASKET',
      fetchBuyTogetherProducts: 'basket/GET_BUY_TOGETHER_PRODUCT',
      fetchPromoOffers: 'basket/GET_PROMO_OFFERS',
      checkSamples: 'samples/CHECK_SAMPLES',
      checkGifts: 'gifts/CHECK_GIFTS',
      checkSales: 'sales/CHECK_SALES',
      removeSelectedGift: 'gifts/REMOVE_SELECTED_GIFT'
    }),
    ...mapMutations({
      increment: 'basket/INCREMENT_BASKET_LIST_COUNT',
      decrement: 'basket/DECREMENT_BASKET_LIST_COUNT',
      setCount: 'basket/SET_BASKET_LIST_COUNT',
      remove: 'basket/REMOVE_ITEM_FROM_BASKET',
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      modalOpen: `app/MODAL_OPEN`,
      modalClose: `app/MODAL_CLOSE`,
      setRemovedSampler: 'samples/SET_REMOVED_SAMPLER',
      resetRemovedSamples: 'samples/RESET_REMOVED_SAMPLES'
    }),
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const bandA = a.value;
      const bandB = b.value;

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    /** @param {Product} product */
    addBasket(product) {
      let sorted = product.productPrices.data.sort(this.compare);
      let selectedProductPrice = sorted[1] ? sorted[1] : sorted[0];
      this.productsKey += 1;

      if (product.hasDuplicate) {
        this.$toasted.info('Цей товар переміщено до новї серії та не можливо купи');
        return;
      }

      this.addToBasket({
        select_count: 1,
        product_price: selectedProductPrice,
        product: product,
        unauthorizedProductPriceId: product.unauthorizedProductPriceId
      });
      fbq('track', 'AddToCart', {
        content_type: 'product',
        currency: 'UAH',
        value: selectedProductPrice.price,
        content_name: product.title,
        content_ids: product.unauthorizedProductPriceId,
        content_category: product.brandSeries?.title || product.brand?.title || product.title
      });
    },

    checkOrderCart: debounce(async function () {
      try {
        let payloadSyncProductsBasket = this.basket.map(({ id, select_count }) => ({
          id,
          count: select_count
        }));

        await this.getSyncBasket(payloadSyncProductsBasket);

        let payloadSyncAddsBasket = this.basket.reduce((acc, { select_type, select_count }) => {
          acc[`products[${select_type.id}]`] = select_count;
          return acc;
        }, {});

        await Promise.all([
          this.checkGifts(payloadSyncAddsBasket),
          this.checkSamples(payloadSyncAddsBasket),
          this.checkSales(payloadSyncAddsBasket)
        ]);
      } catch (e) {
        console.error(e);
      } finally {
        this.syncPriceProductId = null;
      }
    }, 500),

    getLargeValue(products) {
      return products[0];
    },
    isShowOldPrice(product) {
      let { oldPrice, hasActivePromotion } = product.select_type;
      return hasActivePromotion || oldPrice;
    },
    onClosePopup() {
      document.getElementById('html').classList.remove('hide');
      this.modalClose('basketModal');
    },
    async onGoToOrder() {
      // if (!this.isAuthenticated) {
      //     this.changeLoginPopup(true);
      //     return;
      // }

      try {
        let payloadSyncAddsBasket = this.basket.reduce((acc, { select_type, select_count }) => {
          acc[`products[${select_type.id}]`] = select_count;
          return acc;
        }, {});
        await this.checkGifts(payloadSyncAddsBasket);
      } catch (e) {
        console.error(e);
      }

      if (this.hasUnselectedGifts) {
        this.modalOpen('selectGift');
        return;
      }

      document.getElementById('html').classList.remove('hide');
      this.modalClose('basketModal');
      this.navigateTo('buy-flow-order');
    },
    async onRemoveProduct(item) {
      this.remove(item);
      await this.checkOrderCart();
    },

    onRemoveSampler(id) {
      this.setRemovedSampler(id);
    },
    onRemoveGift(gift) {
      this.removeSelectedGift({
        giftGroupId: gift.giftGroupId,
        productPriceId: gift.productPriceId
      });
    },

    /**
     *
     * @param {string} type
     * @param count
     * @param {BasketProduct} basketProduct
     */
    async onChangeCount(type, count = 1, basketProduct) {
      this.syncPriceProductId = basketProduct.id;
      if (type === 'increment') {
        this.increment(basketProduct);
      } else if (type === 'decrement') {
        this.decrement(basketProduct);
      } else {
        if (count) {
          this.setCount({
            product: basketProduct,
            select_count: parseInt(count)
          });
        }
      }
      await this.checkOrderCart();
    },
    async getBuyTogetherProducts() {
      await this.fetchBuyTogetherProducts({ ids: _.map(this.basket, 'id') });
      this.carouselKey += 1;
    },
    async getPromoOffers() {
      await this.fetchPromoOffers();
      this.promoCarouselKey += 1;
    },
    shouldShowArrows(length) {
      switch (true) {
        case window.innerWidth > 672 && length >= 4:
          return true;
        case window.innerWidth < 672 && window.innerWidth > 500 && length >= 3:
          return true;
        case window.innerWidth <= 500 && length >= 2:
          return true;
        default:
          return false;
      }
    },
    showNext() {
      this.$refs.productsSlider.next();
    },
    showPrev() {
      this.$refs.productsSlider.prev();
    },
    showNextPromo() {
      this.$refs.promoSlider.next();
    },
    showPrevPromo() {
      this.$refs.promoSlider.prev();
    }
  }
};
